import { PositionEnum } from '../constants/PositionEnum';

export const getPositionTranslationKey = (position: string): string => {
  switch (position) {
    case 'Left Side':
      return PositionEnum.LEFT_SIDE;
    case 'Right Side':
      return PositionEnum.RIGHT_SIDE;
    case 'General Day':
      return PositionEnum.GENERAL_DAY;
    case 'General Night':
      return PositionEnum.GENERAL_NIGHT;
    case 'Sitting':
      return PositionEnum.SITTING;
    case 'Prone':
      return PositionEnum.PRONE;
    case 'Supine':
      return PositionEnum.SUPINE;
    case 'Wheelchair':
      return PositionEnum.WHEELCHAIR;
    default:
      return position;
  }
};